import { ReactNode } from 'react'

export interface StatItem {
  label: string
  value: ReactNode
}

export const Statistic = ({ label, value }: StatItem) => (
  <div className="flex flex-col items-center gap-2 px-2 md:px-4 lg:px-6 py-3">
    <span className="text-sm text-gray-500 text-center">{label}</span>
    <div className="flex items-center gap-1 text-center">{value}</div>
  </div>
)

interface StatsBarProps {
  items: StatItem[]
}

export const StatsBar = ({ items }: StatsBarProps) => (
  // Below lg the stats wrap onto several rows: forcing every stat into one
  // row (grid-flow-col) made the widest ones — a full submission date, say —
  // push the whole page wider than a phone screen.
  <div className="grid grid-cols-2 gap-y-4 sm:grid-cols-3 lg:grid-cols-none lg:grid-flow-col lg:gap-y-0 justify-items-stretch sm:px-2 md:px-4 lg:px-0 py-6 bg-white rounded-xl lg:divide-x">
    {items.map((item, index) => (
      <Statistic key={index} label={item.label} value={item.value} />
    ))}
  </div>
)
